// extracted by mini-css-extract-plugin
module.exports = {"oneCard":"card-preview_oneCard__uvMxd","title":"card-preview_title__KIbuC","imgShape":"card-preview_imgShape__tonzF"};